import axios from 'axios';

const UPLOAD_URL = 'https://gotoreconfiles.com/cors_new_server.php';

export const sanitizeFilePart = value => String(value || '').replace(/[^a-zA-Z0-9._-]/g, '-');

export const todayStamp = () => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}${month}${day}`;
};

export const fileExtension = (name) => {
  const parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop() : '';
};

export const timestampFileId = file => `${Math.floor(Date.now() / 1000)}_${sanitizeFilePart(file.name)}`;

export const thumbnailFileId = (part_number, file) => {
  const ext = fileExtension(file.name);
  return `${sanitizeFilePart(part_number)}_${todayStamp()}${ext ? `.${ext}` : ''}`;
};

export const extensionFromUrl = (url) => {
  const clean = String(url || '').split('?')[0].split('#')[0];
  const ext = clean.split('.').pop();
  return /^[a-zA-Z0-9]{2,5}$/.test(ext) ? ext.toLowerCase() : 'jpg';
};

export const thumbnailFileIdFromExt = (part_number, ext) => `${sanitizeFilePart(part_number)}_${todayStamp()}.${ext}`;

export const uploadFromUrl = async (url, siteid) => {
  const response = await axios.post(UPLOAD_URL, {
    action: 'upload-from-url',
    url,
    siteid,
  }, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });

  return typeof response.data === 'string' ? response.data.trim() : '';
};

export const uploadToReconFiles = async (file, fileid, siteid) => {
  const form = new FormData();
  form.append('data', file);
  form.append('action', 'put-newserver-file');
  form.append('fileid', fileid);
  form.append('siteid', siteid);

  const response = await axios.post(UPLOAD_URL, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
};
